import userApi from '@/api/user.api'

const roleAgrial = 'CULTURIAL_AGRIAL'
const module = {
  namespaced: true,

  state: {
    profil: null
  },

  getters: {
    profil (state) {
      return state.profil
    },
    isUtilisateurAgrial (state) {
      return state.profil && state.profil.roles.includes(roleAgrial)
    },
    hasAccessToAdherent (state) {
      const rolesAdherentAccess = ['CULTURIAL_LECTURE_PORTEFEUILLE', 'CULTURIAL_LECTURE_TOUS_ADHERENTS', 'CULTURIAL_LECTURE_REGION']
      return state.profil.roles.some(r => rolesAdherentAccess.includes(r))
    },
  },

  mutations: {
    SET_PROFIL (state, profil) {
      state.profil = profil
    },
    RESET (state) {
      state.profil = null
    }
  },

  actions: {
    load ({ commit, dispatch }) {
      return userApi.getProfil().then(profil => {
        commit('SET_PROFIL', profil)
        const adherent = {
          numtiers: profil.username,
          full: false // cet adhérent n'a pas toutes les infos de l'adhérent
        }
        dispatch('adherent/selectAdherent', adherent, { root: true })
        return profil
      })
    },
    reset ({ commit, dispatch }) {
      commit('RESET')
      return dispatch('adherent/reset', true, { root: true })
    }
  }
}

export default module
